import type { PermissionState, PluginListenerHandle } from '@capacitor/core';

// 权限状态类型
export type PermissionStatus = {
  canRequestPackageInstalls: PermissionState; // 是否有安装权限
};

// 安装状态类型
export type InstallStatus = {
  success: boolean; // 安装是否成功
  error?: string; // 错误信息（如果有）
};

// 插件接口定义
export interface JustWeiApkUpdaterPlugin {
  // 检查安装权限
  checkPermissions(): Promise<PermissionStatus>;
  // 请求安装权限
  requestPermissions(): Promise<PermissionStatus>;
  // 打开安装设置页面
  openInstallSetting(): Promise<void>;
  // 安装APK文件
  install(options: { apkPath: string }): Promise<InstallStatus>;
  // 监听安装状态变化
  addInstallListener(
    listenerFunc: (status: InstallStatus) => void,
  ): Promise<PluginListenerHandle> & PluginListenerHandle;
  // 移除所有监听
  removeAllListeners(): Promise<void>;
  // 打开指定的设置页面
  openSetting(options: { action: string }): Promise<void>;
  // 打开应用市场,如果不传packageName则打开当前应用的市场页面
  openMarket(options?: { packageName: string }): Promise<void>;
  // // 检查是否有安装权限
  // hasInstallPermission(): Promise<boolean>;
  // // 获取当前安装状态
  // getInstallStatus(): Promise<InstallStatus>;
}
